import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { EndpointService } from '../_services/endpoint.service';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  /**
   * List of white listed url where not need to call api for refresh .. token
   */
  whiteListedAUthUrl = ['signin', 'user/exits', 'jwt/validate-token'];

  constructor(
    private router: Router,
    private http: HttpClient,
    private endpointService: EndpointService,
    private authService: AuthService
  ) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isValidRequestForInterceptor(request.url)) {
      // add authorization header with jwt token if available
      if (request.headers.has('Skip401Interceptor')) {
        const headers = request.headers.delete('Skip401Interceptor');
        return next.handle(request.clone({ headers }));
      } else {
        const pJwtToken = localStorage.getItem('P-JWT-TOKEN');
        const jwtToken = pJwtToken? pJwtToken: localStorage.getItem('JWT-TOKEN');
        if (jwtToken && !request.headers.has('Authorization')) {
          request = this.addToken(request, jwtToken);
        }
        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {
            switch (error.status) {
              case 401:
                break;
                // return this.handlerFor401(request, next);
              case 403:
                break;
                // this.handlerFor403(request, next);
            }
            // notify user here
            return throwError(error);
          }));
      }
    }
    return next.handle(request);
  }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({ setHeaders: { Authorization: 'Bearer ' + token } });
  }

  handlerFor401(req: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);
      const headers: HttpHeaders = new HttpHeaders({
        Skip401Interceptor: ''
      });
      const refreshToken = localStorage.getItem('JWT-REFRESH-TOKEN');
      return this.http.post<any>(this.endpointService.loginUrl(), refreshToken, { observe: 'response', headers })
        .pipe(
          finalize(() => this.isRefreshingToken = false),
          switchMap(
            resp => {
              this.authService.clearTokensOfLocalstorage();
              const jwtToken = resp.headers.get('JWT-TOKEN');
              const pJwtToken = resp.headers.get('P-JWT-TOKEN');
              const newRefreshToken = resp.headers.get('JWT-REFRESH-TOKEN');
              if (jwtToken && newRefreshToken) {
                localStorage.setItem('JWT-TOKEN', jwtToken);
                if (pJwtToken) {
                  localStorage.setItem('P-JWT-TOKEN', pJwtToken);
                }
                localStorage.setItem('JWT-REFRESH-TOKEN', newRefreshToken);
                this.tokenSubject.next(jwtToken);
                return next.handle(this.addToken(req, jwtToken));
              }
              this.logout();
              return throwError(new Error('oops! no token'));
            }
          ),
          catchError(
            (error, ca) => {
              this.logout();
              return throwError(error);
            }
          ));
    } else {
      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.addToken(req, token));
        }));
    }
  }

  /**
   * While http throw 403,
   * Open access denied comman dialog
   * @param req http request url control
   * @param next handler for http request
   */
  handlerFor403(req: HttpRequest<any>, next: HttpHandler) {
    this.logout();
    throw new Error('403 not implemented');
  }

  async logout() {
    this.authService.clearTokensOfLocalstorage();
    if (!this.router.url.includes('returnUrl') && !this.router.url.includes('auth')) {
      this.router.navigate(['/auth', { outlets: { sb: null } }], { queryParams: { returnUrl: this.router.url } });
    }
  }

  /**
   * Check whether request url is valid for append refresh token call..
   * @param requestUrl requested uri ..
   */
  isValidRequestForInterceptor(requestUrl: string): boolean {
    const positionIndicator = 'api/v1.0/';
    const position = requestUrl.indexOf(positionIndicator);
    if (position > 0) {
      const destination: string = requestUrl.substr(position + positionIndicator.length);
      for (const address of this.whiteListedAUthUrl) {
        if (new RegExp(address).test(destination)) {
          return false;
        }
      }
    }
    return true;
  }
}
